import script from "./AccountForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountForm.vue?vue&type=script&setup=true&lang=ts"

import "./AccountForm.vue?vue&type=style&index=0&id=50f08897&lang=css"
import "./AccountForm.vue?vue&type=style&index=1&id=50f08897&lang=scss"

const __exports__ = script;

export default __exports__